import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/wedding/Navigation";
import TravelStay from "@/components/wedding/TravelStay";
import Accommodation from "@/components/wedding/Accommodation";
import GranadaGuide from "@/components/wedding/GranadaGuide";
import { wedding } from "@/lib/weddingData";

const LogisticsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="relative min-h-screen bg-[#ECE7DC] text-[#0a0a0a]"
      data-testid="logistics-page"
    >
      <Navigation />

      <main className="pt-24 md:pt-28">
        {/* Page title */}
        <section className="mx-auto max-w-[1400px] px-6 pt-12 pb-20 md:px-10 md:pt-20 md:pb-28">
          <Link
            to="/"
            data-testid="logistics-back-link"
            className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-[#8a8580] hover:text-[#0a0a0a]"
          >
            <ArrowLeft
              strokeWidth={1.5}
              className="h-4 w-4 transition-transform duration-500 group-hover:-translate-x-1"
            />
            Volver a la principal
          </Link>
          <p className="mt-10 corner-label text-[#8a8580]">Guía práctica</p>
          <h1 className="mt-6 display-xl">
            Granada
            <br />
            <span className="italic-serif">de arriba abajo.</span>
          </h1>
          <p className="mt-8 max-w-xl body-lead text-lg md:text-xl">
            Cómo llegar hasta {wedding.city}, dónde dormir y qué hacer para
            aprovechar al máximo vuestra estancia.
          </p>
        </section>

        <TravelStay />
        <Accommodation />
        <GranadaGuide />

        {/* Back to home */}
        <div className="mx-auto max-w-[1400px] px-6 pb-24 md:px-10 md:pb-32">
          <Link
            to="/"
            data-testid="logistics-home-link"
            className="btn-base btn-outline group"
          >
            <ArrowLeft
              strokeWidth={1.5}
              className="h-4 w-4 transition-transform duration-500 group-hover:-translate-x-1"
            />
            <span>Volver a la página principal</span>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default LogisticsPage;
